import React from 'react';
import {Button, Form, InputGroup, Spinner} from "react-bootstrap";
import axios from "axios";
import {withRouter} from "react-router";

import {API_ROOT, ERROR_MSGS, INVALID_EMAIL, REGEX_EMAIL, SOURCE_LOGIN, USER_TRIAL_EXPIRED} from "../constants";
import Footer from "../components/Footer";
import HomeHeader from "../components/HomeHeader";
import ProPlans from "../components/ProPlans";
import BorderButton from "../components/BorderButton/index.b";
import {validateDisallowedEmails} from "../utils/general";
import SocialLogin from "../components/SocialLogin/SocialLogin";

import './Login.css';

const LOGGED_IN = 'LOGGED_IN';
const REQUIRE_EMAIL = 'REQUIRE_EMAIL';
const REQUIRE_EMAIL_PASSWORD = 'REQUIRE_EMAIL_PASSWORD';
const RESET_PASSWORD = 'RESET_PASSWORD';
const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
const LOGIN_ERROR = 'LOGIN_ERROR';
const LOADING = 'LOADING';
const REQUIRE_UPGRADE = 'REQUIRE_UPGRADE';

function getErrorMessage(error) {
  if (error === INVALID_EMAIL) {
    return 'Please enter a genuine email address.'
  } else {
    return 'Sorry, unable to send you an email.'
  }
}

const DEFAULT_STATE = {
  stage: REQUIRE_EMAIL,
  error: undefined,
};

class Login extends React.Component {

  state = DEFAULT_STATE;

  componentDidMount() {
    if (localStorage.getItem('token')) {
      this.setState({
        stage: LOGGED_IN
      })
    }
  }

  onEmailChange = (e) => {
    const email = e.target.value;
    const isValidEmail = REGEX_EMAIL.test(email.toLowerCase()) && validateDisallowedEmails(email.toLowerCase());
    this.setState({
      email,
      isValidEmail
    })
  };

  handleLogin = () => {
    const { stage } = this.state;
    if (stage === LOGGED_IN) {
      this.props.history.push('/manage')
    } else if (stage === REQUIRE_EMAIL) {
      this.loginWithEmail()
    } else if (stage === LOGIN_SUCCESS) {
      this.retryLogin();
    } else if (stage === LOGIN_ERROR) {
      this.retryLogin();
    } else if (stage === REQUIRE_UPGRADE) {
      this.props.history.push('/pricing')
    }
  }

  retryLogin = () => {
    this.setState(DEFAULT_STATE)
  };

  loginWithEmail = () => {
    this.setState({
      stage: LOADING
    });

    const data = {
      email: this.state.email
    };

    const promoCode = localStorage.getItem('promoCode');
    if (promoCode) {
      data.promoCode = promoCode;
    }

    axios
      .post(`${API_ROOT}/login`,
        data,
        {
          headers: {
            'Content-Type': 'application/json'
          }
        })
      .then(() => {
        this.setState({
          stage: LOGIN_SUCCESS
        })
      })
      .catch((err) => {
        if (err?.response?.data?.code === USER_TRIAL_EXPIRED) {
          this.setState({
            stage: REQUIRE_UPGRADE
          })
        } else if (err?.response?.data?.code === INVALID_EMAIL) {
          this.setState({
            stage: LOGIN_ERROR,
            error: INVALID_EMAIL
          })
        } else {
          this.setState({
            stage: LOGIN_ERROR
          })
        }
      });
  };

  handleKeyDown = (e) => e.key === 'Enter' && this.state.isValidEmail && this.handleLogin(this.state.stage);

  onSignOut = () => {
    localStorage.removeItem('token');
    this.props.history.go(0)
  }

  render() {
    const {isValidEmail, email, stage} = this.state;
    return <div className="body-bg full-height">
      <HomeHeader/>
      <div className="container-login">
        <div className="container-left-b">
          <h5 className="text-start"><b>Log in or sign up</b></h5>
          <div className="text-start mt-3">Sign in with your favourite platform or we'll send you a one-time login link.</div>
          <div className="text-start mt-2 grey">We're password-less.</div>
          <div className="box-100 p-2 login-box mt-4 border-light-grey">
            <h5>Login or sign up</h5>
            {
              stage === LOGGED_IN &&
              <div className="login-message">
                You're logged in
              </div>
            }
            {
              stage === REQUIRE_EMAIL &&
              <InputGroup className="input-group">
                <Form.Control
                  onChange={this.onEmailChange}
                  onKeyPress={this.handleKeyDown}
                  placeholder="Email"
                  aria-label="email"
                  autoFocus={true}
                  type="email"
                />
              </InputGroup>
            }
            {
              stage === LOGIN_SUCCESS &&
              <div className="login-message">
                We've sent a login link to <b>{email}</b>
              </div>
            }
            {
              stage === LOGIN_ERROR &&
              <div className="login-message">
                {getErrorMessage(this.state.error)}
                <p className="link" onClick={() => window.$crisp.push(['do', 'chat:open'])}>
                  <u>Contact support</u>
                </p>
              </div>
            }
            {
              stage === REQUIRE_UPGRADE &&
              <div className="login-message ps-3 pe-3">{ERROR_MSGS[USER_TRIAL_EXPIRED]}</div>
            }
            {stage !== LOADING && <Button
              className="action-btn w-100 mt-2"
              disabled={stage !== LOGGED_IN && !isValidEmail}
              onClick={this.handleLogin}
            >
              {stage === LOGGED_IN && 'Continue'}
              {stage === REQUIRE_EMAIL && 'Email Me Login Link'}
              {stage === REQUIRE_EMAIL_PASSWORD && 'Login'}
              {stage === LOGIN_SUCCESS && 'Try again'}
              {stage === LOGIN_ERROR && 'Try again'}
              {stage === REQUIRE_UPGRADE && 'Upgrade to Pro'}
            </Button>}
            {stage === LOGGED_IN && <div className="mt-2 font-small">or <span className="link" onClick={this.onSignOut}>Sign out</span></div>}
            {stage === LOADING && <Spinner className="mt-3" animation="border"/>}
            {stage === REQUIRE_EMAIL && <>
              <div className="separator mt-3 w-75 ms-auto me-auto">Or login with</div>
              <SocialLogin className="mt-3" />
            </>}
          </div>
          <div className="toc">
            By using our service you accept our <a href="https://tiiny.host/termsofservice.html" target="_blank">
            <u>terms & conditions</u></a> & <a href="https://tiiny.host/privacypolicy.html" target="_blank">
            <u>privacy policy</u></a>
          </div>
        </div>
        <div className="container-right">
          <h5 className="text-start"><b>Upgrade for more</b></h5>
          <p className="text-start w-75">Upgrade to <b>host sites for longer</b> & manage them all from a simple
            dashboard and more.</p>
          <BorderButton className="text-start learn-more" label="Learn More →" onClick={() => this.props.history.push('/pricing')}/>
          <div className="container-cards mt-5">
            <ProPlans
              onProClick={this.showModal}
              source={SOURCE_LOGIN}
              hideFreeCard
            />
          </div>
        </div>
      </div>
      <Footer/>
    </div>
  }
}

export default withRouter(Login);
